(() => {
  if (window.__amcConversionPathBound) return;
  window.__amcConversionPathBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-amc-funnel-action]');
    if (!link) return;
    const owner = link.closest('[data-amc-conversion-path]');
    if (!owner) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function' ||
        !privacy.analyticsProcessingAllowed()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'amc_conversion_path_click',
      action: link.dataset.amcFunnelAction,
      category_handle: owner.dataset.category,
      landing_path: location.pathname
    });
  }, {passive: true});
})();
